import React, { useState, useEffect } from "react";
import Select from "react-select";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import {
  getPaymentModeKeyValueList,
  getTdsKeyValuePair,
  getInvoiceDetailsByUUID,
  addSalesPayment,
} from "../../../services/index";
import { Link, useNavigate, useParams } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";

const SalesPayment = () => {
  let { id } = useParams();
  const navigate = useNavigate();
  var curr = new Date();
  curr.setDate(curr.getDate());
  var date1 = curr.toISOString()?.substring(0, 10);

  const [payModeOptions, setPayModeOptions] = useState([]);
  const [tdsOptions, setTdsOptions] = useState([]);

  const [payInfo, setPayInfo] = useState({
    customer: "",
    payMode: "",
    taxDeduct: false,
    amount: "",
    bankCharge: "",
    date: date1,
    tds: "",
    ref: "",
    note: "",
  });

  const handleData = (e, key) => {
    if (e.value && e.label) {
      setPayInfo({
        ...payInfo,
        [key]: e,
      });
    } else {
      setPayInfo({
        ...payInfo,
        [e.target.name]: e.target.value,
      });
    }
  };

  useEffect(() => {
    getTdsKeyValuePair().then((res) => {
      if (res.errorCode === 0) {
        const options = res.responsePacket.map((d) => ({
          value: d.key,
          label: d.value,
        }));
        setTdsOptions(options);
      }
    });
    getPaymentModeKeyValueList().then((res) => {
      if (res.errorCode === 0) {
        const options = res.responsePacket.map((d) => ({
          value: d.key,
          label: d.value,
        }));
        setPayModeOptions(options);
      } else {
        toast.error(res.message);
      }
    });

    getInvoiceDetailsByUUID(id).then((res) => {
      if (res.errorCode === 0) {
        let d = res.responsePacket;
        d.taxDeduct = "no";
        d.date = date1;
        d.note = "";
        d.bankCharge = 0;
        setPayInfo(d);
      } else {
        toast.error(res.message);
      }
    });
  }, []);

  const handleSalesPayment = () => {
    if (!payInfo.payMode) {
      toast("Please select payMode");
      return;
    }

    if (payInfo.taxDeduct === "yes" && !payInfo.tds) {
      toast("Please select tds");
      return;
    }
    let request = {
      customerTitle: payInfo?.customerTitle,
      customerId: payInfo?.customerId,
      customerEmail: payInfo?.customerEmail,
      customerPan: payInfo?.customerPan,
      invoiceId: payInfo?.recordId,
      paymentDate: payInfo.date,
      amountReceived: payInfo.amountDue.toFixed(2),
      isTdsDeducted: payInfo?.taxDeduct === "yes" ? true : false,
      bankCharge:payInfo.bankCharge,
      paymentModeId: payInfo.payMode?.value,
      paymentModeTitle: payInfo.payMode?.label,

      thankYouNote: payInfo?.note,

      accountId: "e0ebbd3e-31bc-43c1-ac36-e01be0801d82",
      accountTitle: "Income",
      accountTypeEnum: "Income",
    };

    if (payInfo?.taxDeduct === "yes") {
      request.tdsId = payInfo?.tds?.value;
      request.tdsTitle = payInfo?.tds?.label;
    }

    addSalesPayment(id, request).then((res) => {
      if (res.errorCode === 0) {
        toast.success(res.message);
        navigate("/salesPaymentlist");
      } else {
        toast.error(res.message);
      }
    }).catch(() => {
      toast.error("server error");
      return
    });
  };

  return (
    <>
      <div className=" content-column txn-creation-column">
        <div id="ember716" className="ember-view">
          <div className="scroll-y noscroll-x fill body scrollbox">
            <div className="fill-container row header-separator" />
            <form>
            <br/>
              <h3>SALES PAYMENT</h3>
              <div className="payment">
                <br />
                <div className="zb-txn-form">
                  <div className="form-group row">
                    <label className="col-form-label col-lg-2 required">
                      Customer
                    </label>
                    <div className="col-lg-5">
                      <input
                        disabled="true"
                        className="form-control"
                        value={payInfo.customerTitle}
                      />
                    </div>
                  </div>
                  <div>
                    <div className="form-group row">
                      <label className="col-form-label col-lg-2 required">
                        Amount Received
                      </label>
                      <div className="col-lg-10">
                        <div className="row">
                          <div className="col-lg-2">
                            <div className="input-group">
                              <input
                                disabled="true"
                                className="form-control"
                                value={payInfo.amountDue}
                              />
                            </div>

                            <div
                              id="ember720"
                              className="popover-container ember-view"
                            >
                              <div
                                id="ember721"
                                className="d-none popover bs-popover-bottom ember-view pop-over-div"
                              ></div>
                            </div>
                          </div>
                          <label className="col-form-label col-lg-2 px-0">
                            Bank Charges
                          </label>
                          <div className="col-lg-2">
                            <input
                              autoComplete="off"
                              className="form-control"
                              type="number"
                              name="bankCharge"
                              value={payInfo.bankCharge}
                              onChange={(e) => handleData(e)}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-form-label col-lg-2 required">
                        Payment Date
                      </label>
                      <div className="col-lg-5">
                        <input
                          autoComplete="off"
                          className="form-control"
                          type="date"
                          name="date"
                          value={payInfo.date}
                          onChange={(e) => handleData(e)}
                        />
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-form-label col-lg-2">
                        Payment Mode
                      </label>
                      <div className="col-lg-5">
                        <div className="ember-view">
                          <div className="ac-box ">
                            <Select
                              options={payModeOptions}
                              value={payInfo.payMode}
                              onChange={(e) => handleData(e, "payMode")}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-form-label col-lg-2">
                        Reference#
                      </label>
                      <div className="col-lg-5">
                        <input
                          autoComplete="off"
                          maxLength={50}
                          className="form-control"
                          name="ref"
                          value={payInfo.ref}
                          onChange={(e) => handleData(e)}
                        />
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-form-label col-lg-2">
                        Tax deducted?
                      </label>
                      <div className="col-lg-10 align-self-center">
                        <RadioGroup
                          row
                          name="taxDeduct"
                          value={payInfo?.taxDeduct}
                          onChange={(e) => handleData(e)}
                        >
                          <FormControlLabel
                            control={<Radio size="small" />}
                            value="no"
                            label="No Tax deducted"
                          />
                          <FormControlLabel
                            control={<Radio size="small" />}
                            value="yes"
                            label="Yes, TDS (Income Tax)"
                          />
                        </RadioGroup>
                      </div>
                    </div>

                    {payInfo.taxDeduct === "yes" ? (
                      <>
                        <div className="form-group row">
                          <label className="col-form-label col-lg-2 required">
                            TDS Tax Account
                          </label>{" "}
                          <div className="col-lg-5">
                            <div id="ember3454" className="ember-view">
                              <div className="ac-box ">
                                <Select
                                  options={tdsOptions}
                                  value={payInfo.tds}
                                  onChange={(e) => handleData(e, "tds")}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    ) : (
                      <></>
                    )}

                    <table
                      className="table line-item-table col-8"
                      style={{ paddingTop: "15px", paddingBottom: "30px" }}
                    >
                      <thead>
                        <tr className="line-item-header">
                          <th>Date</th>
                          <th>Invoice Number</th>
                          <th>Invoice Amount</th>
                          <th> Amount Due</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{payInfo.invoiceDate}</td>
                          <td>{payInfo.invoiceNo}</td>
                          <td>{payInfo.totalAmount}</td>
                          <td>{payInfo.amountDue}</td>
                        </tr>
                      </tbody>
                    </table>

                    <div
                      className="form-group"
                      style={{ paddingTop: "15px", paddingBottom: "30px" }}
                    >
                      <label>Notes (For Internal use.)</label>
                      <textarea
                        rows={2}
                        className="form-control col-7"
                        name="note"
                        value={payInfo.note}
                        onChange={(e) => handleData(e)}
                      />
                    </div>

                    <div className="btn-toolbar  fill-container">
                      <button
                        className="btn btn-primary ember-view"
                        type="button"
                        style={{ marginLeft: "15px" }}
                        onClick={handleSalesPayment}
                      >
                        Save
                      </button>

                      <Link to={"/invoices"}>
                        <button
                          className="btn btn-light "
                          type="button"
                          data-ember-action=""
                          data-ember-action-598="598"
                        >
                          Cancel
                        </button>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      <Toaster />
    </>
  );
};

export default SalesPayment;
